import React from "react";

const Qualify = () => {
  return (
    <div className="bg-green-700 py-8 max-tab:mb-0.5" id="qualify">
      <div className="container px-4">
        <h2 className="text-4xl text-white border-b-4 lg:text-center border-b-[#ff9a02] pb-6 mb-6 font-bold">
          Do I qualify for the Texas Debt Relief Program?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          <div className="bg-green-900 shadow p-4 rounded-2xl h-full flex gap-3 items-center">
            <img src="/images/Icon1.png" width={80} alt="Icon" />
            <h3 className="font-bold text-white text-2xl xl:text-xl">
              You must be a Texas Resident.
            </h3>
          </div>
          <div className="bg-green-900 shadow p-4 rounded-2xl h-full flex gap-3 items-center">
            <img src="/images/Icon2.png" width={80} alt="Icon" />
            <div>
              <h3 className="font-bold text-white text-2xl xl:text-xl">
                You have HIGH unsecured debt.
              </h3>
              <small className="text-white font-semibold">
                (credit cards, personal loans, some business debt)
              </small>
            </div>
          </div>
          <div className="bg-green-900 shadow p-4 rounded-2xl h-full flex gap-3 items-center">
            <img src="/images/Icon3.png" width={80} alt="Icon" />

            <h3 className="font-bold text-white text-2xl xl:text-xl">
              Your monthly payments are too high.
            </h3>
          </div>
          <div className="bg-green-900 shadow p-4 rounded-2xl h-full flex gap-3 items-center">
            <img src="/images/Icon4.png" width={80} alt="Icon" />

            <h3 className="font-bold text-white text-2xl xl:text-xl">
              You need an affordable monthly plan.
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Qualify;
